import { useEffect, useMemo, useRef } from 'react';

export const useDataFetch = <T extends Record<string, any>>(
  fetchFn: (filters: T) => void,
  filters: T,
  isUninitialized: boolean
) => {
  const hasLoadedRef = useRef(false);
  const prevFiltersRef = useRef<string>('');
  const filtersString = useMemo(() => JSON.stringify(filters), [filters]);

  useEffect(() => {
    if (!hasLoadedRef.current && isUninitialized) {
      hasLoadedRef.current = true;
      prevFiltersRef.current = filtersString;
      fetchFn(filters);
      return;
    }

    if (prevFiltersRef.current !== filtersString) {
      hasLoadedRef.current = true;
      prevFiltersRef.current = filtersString;
      fetchFn(filters);
    }
  }, [isUninitialized, filtersString, fetchFn, filters]);
};
